module.exports = __webpack_public_path__ + "img/no-record.227423bd.svg";